
import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';

interface ContactFormHeaderProps {
  title: string;
  subtitle: string;
}

const ContactFormHeader: React.FC<ContactFormHeaderProps> = ({ title, subtitle }) => {
  const isMobile = useIsMobile();
  
  return (
    <div className={`${isMobile ? 'pt-24' : 'pt-32 md:pt-48'} pb-6 md:pb-10 bg-white`}>
      <div className="container-custom">
        <div className="text-center max-w-2xl mx-auto">
          <h1 className={`${isMobile ? 'text-2xl mb-3' : 'text-3xl md:text-5xl mb-6'} font-serif text-elegant-900 tracking-tight`}>
            {title}
          </h1>
          <p className={`text-elegant-600 ${isMobile ? 'mb-6 text-xs px-3' : 'mb-10 text-sm md:text-base'} max-w-xl mx-auto font-inter font-light uppercase tracking-wide`}>
            {subtitle}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactFormHeader;
